import type { MyParishUpdateRequest, MyParishView } from '@/types/myParish';
import { ApiService } from './api.service';

class MyParishService extends ApiService {
  public async getMyParish(churchId: string): Promise<MyParishView> {
    const url = `/api/v1/churches/${churchId}/my-parish`;
    const response = await this.get<MyParishView>(url);
    return response.data;
  }

  public async updateMyParish(churchId: string, payload: MyParishUpdateRequest): Promise<MyParishView> {
    const url = `/api/v1/churches/${churchId}/my-parish`;
    const response = await this.put<MyParishView>(url, payload);
    return response.data;
  }
}

export const myParishService = new MyParishService();
